import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c9bf5ca4"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "content" };
const _hoisted_2 = { class: "avatar-box" };
const _hoisted_3 = { class: "name-box" };
const _hoisted_4 = { class: "user-name" };
const _hoisted_5 = { class: "top-box" };
const _hoisted_6 = { class: "avatar-box" };
const _hoisted_7 = { class: "account-info" };
const _hoisted_8 = { class: "display-flex align-items" };
const _hoisted_9 = { class: "top-box-user-name omit" };
const _hoisted_10 = { class: "top-box-user-id" };
const _hoisted_11 = { class: "user-type-wrap" };
import CloudAvatar from "@/components/CloudAvatar/index.vue";
import UserType from "@/components/UserType/index.vue";
import { resetRouter } from "@/router";
import { appCounterStore } from "@/store/app";
import { permissionStore } from "@/store/permission";
import { useRegionStore } from "@/store/region";
import { useCounterStore } from "@/store/user";
import VerifyType from "@/views/personal/components/VerifyType.vue";
import { computed, ref } from "vue";
export default /*#__PURE__*/ _defineComponent({
    name: 'personal',
    props: {
        detailInfo: { default: { extra: {} } }
    },
    setup(__props) {
        const useStore = useCounterStore();
        const appStore = appCounterStore();
        const permission = permissionStore();
        const useRegion = useRegionStore();
        const userInfo = useStore.getUserInfo;
        const sidebar = computed(() => appStore.sidebar);
        // const router = useRouter();
        const isShow = ref(false);
        const mouseenter = () => {
            isShow.value = true;
        };
        const mouseleave = () => {
            isShow.value = false;
        };
        const loginOut = async () => {
            permission.resetRouter();
            appStore.setLoginState("login");
            useRegion.$reset();
            await useStore.logout();
            await useStore.resetToken();
            resetRouter();
            /*
             * router.push({
             *   path: `/login`
             * });
             */
            window.location.reload();
        };
        return (_ctx, _cache) => {
            const _component_svg_icon = _resolveComponent("svg-icon");
            return (_openBlock(), _createElementBlock("div", {
                class: "personal-box",
                onMouseenter: mouseenter,
                onMouseleave: mouseleave
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(CloudAvatar, {
                            "show-nickname": false,
                            "show-name": false,
                            name: _unref(userInfo).user_name || '',
                            avatar: _unref(userInfo).avatar || '',
                            "base-size": 16
                        }, null, 8, ["name", "avatar"])
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(userInfo).user_name), 1)
                    ], 512), [
                        [_vShow, !_unref(sidebar)]
                    ]),
                    _withDirectives(_createVNode(_component_svg_icon, {
                        "icon-class": "personal-arrow",
                        "class-name": "arrow-icon"
                    }, null, 512), [
                        [_vShow, !_unref(sidebar)]
                    ]),
                    _createElementVNode("div", {
                        class: _normalizeClass(["info-box drop-transition", { 'drop-border': isShow.value }]),
                        style: _normalizeStyle({ maxHeight: isShow.value ? '284px' : '0px' })
                    }, [
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _createVNode(CloudAvatar, {
                                    "show-nickname": false,
                                    "show-name": false,
                                    name: _unref(userInfo).user_name || '',
                                    avatar: _unref(userInfo).avatar || '',
                                    "base-size": 16
                                }, null, 8, ["name", "avatar"])
                            ]),
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("div", _hoisted_8, [
                                    _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(userInfo).user_name), 1)
                                ]),
                                _createElementVNode("div", _hoisted_10, "账号ID：" + _toDisplayString(_unref(userInfo).user_id), 1)
                            ]),
                            _createElementVNode("div", _hoisted_11, [
                                _createVNode(UserType, {
                                    type: _unref(userInfo).type,
                                    class: "m-l-auto"
                                }, null, 8, ["type"]),
                                _createVNode(VerifyType, {
                                    "verify-type": __props.detailInfo?.extra?.authentication_type,
                                    "is-show": ""
                                }, null, 8, ["verify-type"])
                            ])
                        ]),
                        _createElementVNode("div", { class: "bottom-box" }, [
                            _createElementVNode("div", { onClick: loginOut }, "退出登录")
                        ])
                    ], 6)
                ])
            ], 32));
        };
    }
});
